import React, {useEffect, useState} from 'react';
import LogoImg from "../assets/img/logo.webp";




const Layout = (({logo, children, className}) => {


    const [menuOpen, setMenuOpen] = useState(false);

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
        const body = document.body;
        const classesToToggle = [
            "template-index",
            "data-animations",
            "site-footer--parallax",
            "navigation-open",
        ];
        classesToToggle.forEach((className) => {
            body.classList.toggle(className);
        });
    };


    return (
        <>
            <div className="site-header--transparent">
                <header className="site-header__wrapper" role="banner">
                    <div className="site-header-sections page-width">
                        <nav
                            className="site-header__section site-header__section--button"
                            data-site-navigation=""
                            role="navigation"
                        >
                            <button
                                id="menuOpen"
                                className="site-header__navigation btn btn--clear btn--square"
                                aria-expanded={menuOpen}
                                data-navigation-button=""
                                onClick={toggleMenu}
                            >
                                <span className="burger-icon burger-icon--top"></span>
                                <span className="burger-icon burger-icon--mid"></span>
                                <span className="burger-icon burger-icon--bottom"></span>
                                <span className="icon__fallback-text">Menu</span>
                            </button>
                            <div
                                className={`navigation supports-no-js critical-hide ${menuOpen ? "open" : ""}`}
                                data-section-id="header"
                                data-section-type="navigation"
                                aria-hidden={!menuOpen}
                                style={{
                                    top: "80px",
                                    minHeight: "calc(-80px + 100vh)",
                                    maxHeight: "calc(-80px + 100vh)",
                                }}
                            >
                                <div className="navigation__container">
                                    <div className="navigation__container">
                                        <ul className="navigation__links">


                                            <li className="navigation__link navigation__entrance-animation navigation__link--active navigation__entrance-animation--active">
                                                <a href="/" aria-current="page">HOME</a>
                                            </li>


                                            <li className="navigation__link navigation__entrance-animation navigation__entrance-animation--active">
                                                <a href="/services/">SERVICES</a>
                                            </li>


                                        </ul>

                                        <ul className="navigation__links">


                                            {/*<li className="navigation__link navigation__link--secondary navigation__entrance-animation navigation__entrance-animation--active">*/}
                                            {/*    <a href="/account/login">Log in</a>*/}
                                            {/*</li>*/}
                                            {/*<li className="navigation__link navigation__link--secondary navigation__entrance-animation navigation__entrance-animation--active">*/}
                                            {/*    <a href="/account/register">Create account</a>*/}
                                            {/*</li>*/}


                                            <li className="navigation__link navigation__link--secondary navigation__entrance-animation navigation__entrance-animation--active">
                                                <a href="/about">ABOUT</a>
                                            </li>

                                            <li className="navigation__link navigation__link--secondary navigation__entrance-animation navigation__entrance-animation--active">
                                                <a href="/contact-us">CONTACT</a>
                                            </li>

                                            <li className="navigation__link navigation__link--secondary navigation__entrance-animation navigation__entrance-animation--active">
                                                <a href="/terms-of-service">TERMS</a>
                                            </li>

                                            <li className="navigation__link navigation__link--secondary navigation__entrance-animation navigation__entrance-animation--active">
                                                <a href="/privacy-policy">PRIVACY</a>
                                            </li>

                                        </ul>


                                        <div
                                            className="navigation__social-sharing navigation__entrance-animation navigation__entrance-animation--active">
                                            <div className="social-links social-links--large">
                                                <ul className="list--inline">


                                                    <li className="social-links__icon">
                                                        <a target="_blank" href="https://x.com/boucmedia"
                                                           title="Bouc on Twitter">
                                                            <svg aria-hidden="true" focusable="false"
                                                                 role="presentation"
                                                                 className="icon icon-twitter" viewBox="0 0 20 20">
                                                                <path fill="#444"
                                                                      d="M19.551 4.208q-.815 1.202-1.956 2.038 0 .082.02.255t.02.255q0 1.589-.469 3.179t-1.426 3.036-2.272 2.567-3.158 1.793-3.963.672q-3.301 0-6.031-1.773.571.041.937.041 2.751 0 4.911-1.671-1.284-.02-2.292-.784T2.456 11.85q.346.082.754.082.55 0 1.039-.163-1.365-.285-2.262-1.365T1.09 7.918v-.041q.774.408 1.773.448-.795-.53-1.263-1.396t-.469-1.864q0-1.019.509-1.997 1.487 1.854 3.596 2.924T9.81 7.184q-.143-.509-.143-.897 0-1.63 1.161-2.781t2.832-1.151q.815 0 1.569.326t1.284.917q1.345-.265 2.506-.958-.428 1.386-1.732 2.18 1.243-.163 2.262-.611z"></path>
                                                            </svg>
                                                            <span className="icon__fallback-text">Twitter</span>
                                                        </a>
                                                    </li>


                                                    <li className="social-links__icon">
                                                        <a target="_blank" href="https://youtube.com/@boucmedia"
                                                           title="Bouc on YouTube">
                                                            <svg aria-hidden="true" focusable="false"
                                                                 role="presentation"
                                                                 className="icon icon-youtube" viewBox="0 0 21 20">
                                                                <path fill="#444"
                                                                      d="M-.196 15.803q0 1.23.812 2.092t1.977.861h14.946q1.165 0 1.977-.861t.812-2.092V3.909q0-1.23-.82-2.116T17.539.907H2.593q-1.148 0-1.969.886t-.82 2.116v11.894zm7.465-2.149V6.058q0-.115.066-.18.049-.016.082-.016l.082.016 7.153 3.806q.066.066.066.164 0 .066-.066.131l-7.153 3.806q-.033.033-.066.033-.066 0-.098-.033-.066-.066-.066-.131z"></path>
                                                            </svg>
                                                            <span className="icon__fallback-text">YouTube</span>
                                                        </a>
                                                    </li>


                                                </ul>
                                            </div>

                                        </div>


                                        {/*<div*/}
                                        {/*    className="navigation__search navigation__entrance-animation navigation__entrance-animation--active">*/}
                                        {/*    <form action="/search" method="get" role="search">*/}
                                        {/*        <div className="input-group--underline">*/}
                                        {/*            <input className="input-group__field" type="search" name="q"*/}
                                        {/*                   value=""*/}
                                        {/*                   placeholder="Search"*/}
                                        {/*                   aria-label="Search"/>*/}
                                        {/*            <div className="input-group__btn">*/}
                                        {/*                <button type="submit"*/}
                                        {/*                        className="btn btn-search btn--clear btn--square">*/}
                                        {/*                    <svg aria-hidden="true" focusable="false"*/}
                                        {/*                         role="presentation"*/}
                                        {/*                         className="icon icon-search" viewBox="0 0 21.4 21.4">*/}
                                        {/*                        <path fill="#444"*/}
                                        {/*                              d="M13.4 0c-4.4 0-8 3.6-8 8 0 1.8.6 3.5 1.7 4.9L0 20l1.4 1.4 7.1-7.1c1.4 1.1 3.1 1.7 4.9 1.7 4.4 0 8-3.6 8-8s-3.6-8-8-8zm0 14c-3.3 0-6-2.7-6-6s2.7-6 6-6 6 2.7 6 6-2.7 6-6 6z"></path>*/}
                                        {/*                    </svg>*/}
                                        {/*                    <span className="icon__fallback-text">Search again</span>*/}
                                        {/*                </button>*/}
                                        {/*            </div>*/}
                                        {/*        </div>*/}
                                        {/*    </form>*/}
                                        {/*</div>*/}

                                    </div>
                                </div>
                            </div>
                        </nav>
                        <div className="site-header__section site-header__section--title">
                            <h1
                                className="site-header__logo-wrapper h4"
                                itemScope=""
                                itemType="http://schema.org/Organization"
                            >
                                <a href="/" itemProp="url" className="site-header__logo">
                                    <img
                                        className="site-header__logo-image"
                                        src={LogoImg}
                                        alt="Bouc"
                                        itemProp="logo"
                                    />

                                    <img
                                        className="site-header__logo-image site-header__logo-image--transparent"
                                        src={LogoImg}
                                        alt="Bouc"
                                        itemProp="logo"
                                    />
                                </a>
                            </h1>
                        </div>

                        <div className={'store-basket'}></div>
                    </div>
                </header>
            </div>
            {children}

            <section className="footer">
                <div className="container footer-nav">
                    <div className="nav nav-box">
                        <a href={'/about'} className="nav-item">ABOUT </a>
                        <a href="/contact-us" className="nav-item">CONTACT </a>
                        <a href="/terms-of-service" className="nav-item">TERMS</a>
                        <a href="/privacy-policy" className="nav-item">PRIVACY </a>

                    </div>
                    <p>
                        Copyright © 2024, Bouc.
                    </p>
                </div>
            </section>
        </>
    )
});
export default Layout;
